
import { Options, Vue } from "vue-class-component";
import {onBeforeRouteUpdate } from "vue-router";
import { useStore } from "@/store";
import SidebarItem from "./SidebarItem.vue"
import{MenuList} from "@/constant/menuName"
import{inspectopenMenuList} from "@/constant/inspectopenMenuName"

@Options({
  components:{
    SidebarItem
  },
  watch:{
    '$route.path': {
      handler(newVal:any, oldVal:any) {
       if (newVal === '/dataAnalysis/panelData') {
          this.defaultActive = newVal
          this.showMenu = false
          setTimeout(()=>{this.showMenu = true},100)
       }
      },
      deep: true,
    },
  }
})
export default class Side_bar extends Vue {
  private defaultActive:string='1-1';
  private store = useStore();
  private isCollapse = false
  private showMenu = true
  private menuList:any;
  created(): void {
    if(this.$route.path.indexOf("/inspectopen")>-1){
      this.isCollapse = true;
      this.menuList = inspectopenMenuList;
      this.showMenu = false
      setTimeout(()=>{this.showMenu = true},100)
    }else{
      this.menuList = MenuList;
    }
    let classmonitor = this.$route.query.classmonitor as string;
    if(classmonitor!="" && classmonitor!=undefined && classmonitor!=null){
      this.defaultActive = this.$route.path+"?classmonitor=1";
    }else{
      this.defaultActive = this.$route.path;
    }
  }

  getMenuVal(item:any,indexPath:any){
  }

}
